import { PBCC_PREMIUM } from '../config/siteMode.js'

// Strip a trailing date line (e.g. "July 30th – Aug 2nd, 2026") from a
// tournament name for the TV board headers — the date wastes space and clutters
// the title. A line is treated as a date if it contains a 4-digit year OR a
// month name immediately followed by a day number. TEST-only: the club keeps its
// full name unchanged.
const DATE_LINE = /\b(19|20)\d{2}\b|\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+\d/i

export function boardTitle(name) {
  if (!PBCC_PREMIUM || !name) return name
  return String(name)
    .split('\n')
    .filter((line) => !DATE_LINE.test(line))
    .join('\n')
    .trim()
}
